const ContactForm = class ContactForm {
  constructor(configContactForm) {
    this.formTrigger = configContactForm.formTrigger;
    this.formClose = configContactForm.formClose;
  }

  init() {
    let $formTrigger = this.formTrigger,
        $formClose = this.formClose;

    $formTrigger.on("click", function() {
      const triggerCta = $(this),
            triggerTarget = triggerCta.attr("data-target"),
            closeTrigger = $formClose,
            dataStatus = triggerCta.attr("data-status");
      "off" == dataStatus
        ? (triggerCta.attr("data-status", "on"),
          $(triggerCta).addClass("is-active"),
          $(closeTrigger).addClass("is-active"),
          $(triggerTarget).slideDown())
        : (triggerCta.attr("data-status", "off"),
          $(triggerCta).removeClass("is-active"),
          $(closeTrigger).removeClass("is-active"),
          $(triggerTarget).slideUp());
    });

    $formClose.on("click", function() {
      const closeTrigger = $(this),
            openTrigger = $formTrigger,
            closeTarget = closeTrigger.attr("data-target"),
            openStatus = openTrigger.attr("data-status");
      "off" == openStatus
        ? (openTrigger.attr("data-status", "on"),
          $(openTrigger).addClass("is-active"),
          $(closeTrigger).addClass("is-active"),
          $(closeTarget).slideDown())
        : (openTrigger.attr("data-status", "off"),
          $(openTrigger).removeClass("is-active"),
          $(closeTrigger).removeClass("is-active"),
          $(closeTarget).slideUp());
    });
  }
};

export { ContactForm };



// WEBPACK FOOTER //
// ./static/js/components/ContactForm.js